import { makeStyles, Switch, SwitchOnChangeData, tokens } from '@fluentui/react-components';
import { useFormContext } from 'react-hook-form';
import { ClientOnboardingForm } from '../../../api';
import Stack from '../../layout/Stack';
import { filterEnabledSystems, isMpmEnabled } from '../../../utils/features';
import SubSectionDivider from '../SubSectionDivider';

const useStyles = makeStyles({
    label: {
        fontSize: '14px',
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground1,
    },
    caption: {
        fontSize: '12px',
        fontWeight: tokens.fontWeightRegular,
        color: tokens.colorNeutralForeground3,
    },
});

const SystemsCard = () => {
    const styles = useStyles();
    const { watch, setValue } = useFormContext<ClientOnboardingForm>();
    // When ModernPM creation is disabled (VITE_ENABLE_MPM), MPM is never offered or counted as selected.
    const mpmEnabled = isMpmEnabled();
    const systems = filterEnabledSystems(watch('systems'));

    const handleChange = (system: string) => (_ev: React.ChangeEvent<HTMLInputElement>, data: SwitchOnChangeData) => {
        if (data.checked) {
            setValue('systems', [...systems, system]);
        } else {
            // At least one system (CCH and/or ModernPM) must stay selected — don't allow turning off the last one.
            if (systems.length <= 1) return;
            setValue(
                'systems',
                systems.filter((s) => s !== system)
            );
        }
    };

    // Caption is decorative (aria-hidden) so the switch's accessible name stays the platform name.
    const switchLabel = (name: string, caption: string) => (
        <span className={styles.label}>
            {name} <span className={styles.caption} aria-hidden>· {caption}</span>
        </span>
    );

    return (
        <>
            <SubSectionDivider label="Platforms" first />
            <Stack flexDirection="row" justifyContent="flex-start">
                <Switch
                    label={switchLabel('CCH Axcess', 'Practice management')}
                    checked={systems.includes('CCH')}
                    onChange={handleChange('CCH')}
                />
                {mpmEnabled && (
                    <Switch
                        label={switchLabel('ModernPM', 'Project & billing')}
                        checked={systems.includes('MPM')}
                        onChange={handleChange('MPM')}
                    />
                )}
            </Stack>
        </>
    );
};

export default SystemsCard;
